var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-listing",
      class: {
        hasFilter:
          _vm.filterQuery.status.length ||
          _vm.filterQuery.coordinator.length ||
          _vm.filterQuery.tag.length ||
          _vm.filterQuery.outlet.length
      },
      attrs: { id: "add__project__deliverable" }
    },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleUpdateModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            attrs: { title: _vm.viewBtnLabel, viewId: _vm.activeView },
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createContactModal",
            title: "New Contact"
          },
          on: { shown: _vm.focusContactModal }
        },
        [_c("CreateContactModal", { ref: "refContactModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editContactModal",
            title: "Update Contact"
          },
          on: { shown: _vm.focusUpdateContactModal }
        },
        [_c("UpdateContactModal", { ref: "refUpdateContactModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveProjectDeli },
          model: {
            value: _vm.showRemoveProjectDeli,
            callback: function($$v) {
              _vm.showRemoveProjectDeli = $$v
            },
            expression: "showRemoveProjectDeli"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Are you sure you want to remove deliverable from this project?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createSpokespersonModal",
            title: "New Spokesperson"
          },
          on: { shown: _vm.focusSpokespersonModal }
        },
        [_c("CreateSpokespersonModal", { ref: "refSpokespersonModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createWhoModal",
            title: "New Outlet / Contact"
          },
          on: { shown: _vm.focusWhoModal }
        },
        [_c("CreateWhoModal", { ref: "refWhoModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editSpokespersonModal",
            title: "Update Spokesperson"
          },
          on: { shown: _vm.focusUpdateSpokespersonModal }
        },
        [_c("UpdateSpokespersonModal", { ref: "refUpdateSpokespersonModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editWhoModal",
            title: "Update Outlet / Contact"
          },
          on: { shown: _vm.focusUpdateWhoModal }
        },
        [_c("UpdateWhoModal", { ref: "refUpdateWhoModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: { allContacts: _vm.allContacts, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(_vm.deliverablesArray, function(deliverable, index) {
            return index != "totalOutlets"
              ? _c(
                  "div",
                  {
                    key: "deliverable" + index,
                    staticClass: "deliverable-block read-only"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "overlay-info",
                        class:
                          deliverable.project_id == null ||
                          deliverable.project_id.id !=
                            _vm.$route.params.projectId
                            ? ""
                            : "active--overlay"
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "link-deliverable-btn",
                            class:
                              deliverable.project_id == null ||
                              deliverable.project_id.id !=
                                _vm.$route.params.projectId
                                ? "add-prj"
                                : "remove-prj",
                            attrs: {
                              title:
                                deliverable.project_id == null ||
                                deliverable.project_id.id !=
                                  _vm.$route.params.projectId
                                  ? "Add to Project"
                                  : "Remove from Project"
                            },
                            on: {
                              click: function($event) {
                                deliverable.project_id == null ||
                                deliverable.project_id.id !=
                                  _vm.$route.params.projectId
                                  ? _vm.addToProject(deliverable.id)
                                  : (_vm.showRemoveProjectDeli = true)
                                _vm.removingDeliverableId = deliverable.id
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  deliverable.project_id == null ||
                                    deliverable.project_id.id !=
                                      _vm.$route.params.projectId
                                    ? "Add to Project"
                                    : "Remove from Project"
                                ) +
                                "\n\t\t\t\t"
                            ),
                            deliverable.project_id == null ||
                            deliverable.project_id.id !=
                              _vm.$route.params.projectId
                              ? _c("div", { staticClass: "task-exp" }, [
                                  _vm._m(0, true)
                                ])
                              : _c("div", { staticClass: "task-exp" }, [
                                  _vm._m(1, true)
                                ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "delv-block-resp" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row dbox-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "w-100 dbox-left-side" },
                            [
                              _c("div", { staticClass: "top-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "data-items text-primary" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.deliverableTypeTitle(
                                              deliverable.deliverable_template_id
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "data-items" },
                                  [
                                    _c("DeliverableProjects", {
                                      attrs: {
                                        deliverable: deliverable,
                                        namespace: _vm.namespace
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "data-items" }, [
                                  _c("span", { staticClass: "text-primary" }, [
                                    _vm._v("PRIORITY: ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "listing-priority",
                                      class:
                                        "listing-priority-del-" +
                                        deliverable.id,
                                      attrs: { title: "Priority" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setPriority(deliverable)
                                        }
                                      }
                                    },
                                    [
                                      _c("vue-star-rate", {
                                        key:
                                          "del-rating-" +
                                          Math.random() +
                                          deliverable.id,
                                        attrs: {
                                          rateRange: deliverable.priority
                                            ? Number(deliverable.priority)
                                            : 0,
                                          maxIcon: 5,
                                          iconHeight: 17,
                                          iconWidth: 17,
                                          hasCounter: false,
                                          iconColor: "var(--wf-primary)",
                                          iconColorHover: "var(--wf-primary)",
                                          iconShape: "circle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "data-items" }, [
                                  _c("span", { staticClass: "text-primary" }, [
                                    _vm._v("STARTED:")
                                  ]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("moment")(
                                          deliverable.created_at,
                                          "DD MMM, YYYY @ H:mm"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                deliverable.all_completed
                                  ? _c("div", { staticClass: "data-items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "text-primary" },
                                        [_vm._v("COMPLETED:")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("moment")(
                                              deliverable.completed_at,
                                              "DD MMM, YYYY @ H:mm"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ])
                                  : _c("div", { staticClass: "data-items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "text-primary" },
                                        [_vm._v("LAST MODIFIED:")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("moment")(
                                              deliverable.updated_at,
                                              "DD MMM, YYYY @ H:mm"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ])
                              ]),
                              _vm._v(" "),
                              _c("DeliverableTypeIcon", {
                                attrs: {
                                  deliverableTypeId:
                                    deliverable.deliverable_template_id
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "row listing-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-8 titles breakpoint__fix"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inside-list department--wrap--new"
                                      },
                                      [
                                        _c("DeliverableDepartments", {
                                          attrs: {
                                            deliverable: deliverable,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "deliverable-title edit-d-title",
                                        on: {
                                          click: function($event) {
                                            return _vm.showModalFn(
                                              deliverable.id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(deliverable.title))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-4 infos" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c("DeliverableListCoordinators", {
                                              staticClass:
                                                "deliverable-list-coordinators",
                                              attrs: {
                                                deliverable: deliverable
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("DeliverableListContacts", {
                                              staticClass:
                                                "deliverable-list-contacts",
                                              attrs: {
                                                deliverable: deliverable
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("DeliverableListTags", {
                                              staticClass:
                                                "deliverable-list-tags",
                                              attrs: {
                                                deliverable: deliverable,
                                                namespace: _vm.namespace
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-collapse",
                                        {
                                          attrs: {
                                            visible: _vm.expandAll,
                                            id: "task-listing-collapse-" + index
                                          }
                                        },
                                        [
                                          _vm.isMobile()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 infos responsive-infos"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row"
                                                    },
                                                    [
                                                      _c(
                                                        "DeliverableListCoordinators",
                                                        {
                                                          staticClass:
                                                            "deliverable-list-coordinators",
                                                          attrs: {
                                                            deliverable: deliverable
                                                          }
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "DeliverableListContacts",
                                                        {
                                                          staticClass:
                                                            "deliverable-list-contacts",
                                                          attrs: {
                                                            deliverable: deliverable
                                                          }
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "DeliverableListTags",
                                                        {
                                                          staticClass:
                                                            "deliverable-list-tags",
                                                          attrs: {
                                                            deliverable: deliverable,
                                                            namespace:
                                                              _vm.namespace
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("TaskFields", {
                                            attrs: {
                                              deliverable: deliverable,
                                              deliverableId: deliverable.id,
                                              myWeek: false,
                                              tasks: deliverable.tasks,
                                              users: deliverable.users
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dbox-right-side" },
                            [
                              _c("CollapseTaskBtn", {
                                attrs: {
                                  deliverable: deliverable,
                                  index: index,
                                  expandAll: _vm.expandAll
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.myWeek,
                  expression: "!myWeek"
                }
              ],
              staticClass: "pagination-wrapper"
            },
            [
              _c("pagination", {
                attrs: { data: _vm.allDeliverablesPaginationData, limit: 5 },
                on: { "pagination-change-page": _vm.onChangePage }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("span", { staticClass: "icon close-collase" }, [
        _c("i", { staticClass: "fas fa-plus" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("span", { staticClass: "icon close-collase text-danger" }, [
        _c("i", { staticClass: "fas fa-minus" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }